<template>
<div class="Dialog">
  <el-dialog
      class="customDialog"
      title="提示"
      :visible.sync="isShow"
      :close-on-click-modal = 'false'
       :close-on-press-escape = 'false'
      :modal = '!move'
      :width="width">
    <slot></slot>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '40%'
    },
    move: {
      type: Boolean,
      default: false
    }
  },
  components: { },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    isShow: {
      get: function () {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {},
  filters: {}
}
</script>

<style lang="scss">
.Dialog{
}
</style>
